<script setup>
const props = defineProps({
	numbers: {
		type: Array,
		required: true,
	},
})
const currentNumber = ref(props.numbers[0] || 1)
let intervalId = null

const startNumberRotation = () => {
	let index = 0
	intervalId = setInterval(() => {
		currentNumber.value = props.numbers[index]
		index = (index + 1) % props.numbers.length
	}, 500)
}

onMounted(() => {
	startNumberRotation()
})

onBeforeUnmount(() => {
	clearInterval(intervalId)
})
</script>

<template>
	<div class="relative inline-flex">
		<svg
			width="102"
			height="102"
			class="w-full h-full"
			viewBox="0 0 102 102"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				class="half-circle"
				d="M95.6498 50.8249C95.6498 62.7132 90.9272 74.1146 82.5209 82.5209C74.1146 90.9272 62.7132 95.6498 50.8249 95.6498C38.9366 95.6498 27.5352 90.9272 19.1289 82.5209C10.7226 74.1146 6 62.7132 6 50.8249"
				stroke="currentColor"
				stroke-width="11.9268"
				stroke-linecap="round"
			/>

			<circle
				class="circle-rotate"
				cx="51.125"
				cy="50.8591"
				r="44.8249"
				stroke="currentColor"
				stroke-width="11.9268"
				stroke-linecap="round"
				stroke-dasharray="12.13 43.93"
			/>
		</svg>

		<div
			class="circle-rotate absolute inset-0 flex items-center font-semibold justify-center text-2xl tracking-wide leading-none"
		>
			<span class="number-rotate">{{ currentNumber }}</span>
		</div>
	</div>
</template>

<style scoped>
.half-circle {
	transform-origin: center;
	animation: half-circle 4.6s infinite linear;
}

@keyframes half-circle {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(360deg);
	}
}

.circle-rotate {
	transform-origin: center;
	animation: circle-rotate 2.5s infinite linear;
}

@keyframes circle-rotate {
	0% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(-360deg);
	}
}

.number-rotate {
	animation: number-rotate 1s infinite linear;
}

@keyframes number-rotate {
	30% {
		opacity: 1;
	}
	50% {
		opacity: 0.3;
	}
	70% {
		opacity: 1;
	}
}
</style>
